<template>
  <div class="mgl-10px">
    <div class="card-article-input-selectDateVente columns is-vcentered">
      <div class="has-text-centered" :class="[getColorEncartPicker, {'disabled': disabled}]">
        <a @click="openPopUpParution = true">
          <b-icon
            icon="book-open-outline"
            type="is-white"
            custom-class="mgt-10px">
          </b-icon>
        </a>
      </div>
      <div class="card-article-input-dateParution
      is-size-7 column is-narrow is-paddingless mgl-10px">
        <p>{{ getDateAndParution() }}</p>
      </div>
    </div>
    <b-modal v-model="openPopUpParution" has-modal-card class="modal">
      <pop-up-change-parution :ligne-commande="ligneCommande"
      @close="openPopUpParution = false;"
      @applyParution="$emit('applyParution')">
      </pop-up-change-parution>
    </b-modal>
  </div>
</template>

<script>
import PopUpChangeParution from '@/components/devisCommandes/editionDevisCommande/specLigneArticle/popUpChangeParution';
import formatDate from '@/services/general/formatDate';

export default {
  name: 'parutionPresse',
  components: { PopUpChangeParution },
  props: {
    ligneCommande: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      openPopUpParution: false,
    };
  },
  computed: {
    getColorEncartPicker() {
      if (!this.ligneCommande.parutionId) return 'card-article-input-datepicker-warning';
      if (this.ligneCommande.parutionId && this.ligneCommande.parution
        && this.ligneCommande.parution.ratioRestant <= 0) {
        return 'card-article-input-datepicker-danger';
      }
      return 'card-article-input-datepicker-success';
    },
  },
  methods: {
    getDateAndParution() {
      if (!this.ligneCommande.dateDebut || !this.ligneCommande.dateFin) return this.$t('detail.article.needParution');
      if (this.ligneCommande.parutionId && this.ligneCommande.parution
        && this.ligneCommande.parution.ratioRestant <= 0) {
        return this.$t('detail.article.parutionNotAvailable');
      }
      return this.$t('detail.article.parutionDu', { date: formatDate(this.ligneCommande.dateDebut), code: this.ligneCommande.parution.nomParution });
    },
  },
};
</script>

<style scoped>

</style>
